import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { ParagraphProps } from "./ParagraphProps";
import { MarkdownHtml } from "@easy/ui/text";


export default /*@__PURE__*/_defineComponent({
  __name: 'ParagraphComponent',
  props: {
    text: {},
    textColor: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(MarkdownHtml), {
    class: "text-md xl:text-lg/8 text-balance opacity-70",
    markdown: _ctx.text,
    style: _normalizeStyle({ color: _ctx.textColor })
  }, null, 8, ["markdown", "style"]))
}
}

})